/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CndnRequest } from '../../models/cndn-request';

export interface ApiRequestCndnGetRequestByIdGet$Params {
  id?: string;
}

export function apiRequestCndnGetRequestByIdGet(http: HttpClient, rootUrl: string, params?: ApiRequestCndnGetRequestByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CndnRequest>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCndnGetRequestByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CndnRequest>;
    })
  );
}

apiRequestCndnGetRequestByIdGet.PATH = '/api/Request/Cndn/GetRequestById';
